import { Mail, Github, Linkedin, Twitter, Facebook, Instagram, Youtube } from "lucide-react";
import { SiTiktok, SiPinterest, SiReddit, SiVimeo, SiSnapchat } from "react-icons/si";

// Shared navigation config (used by Navigation + SiteFooter)
export const NAV_ITEMS = [
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Store" },
  { id: "network", label: "Network" },
  { id: "contact", label: "Contact" }
];

// Footer Quick Links (currently same as nav; kept separate so they can diverge later)
export const FOOTER_LINKS = NAV_ITEMS;

// Social links shown in the footer. `brand` is the official brand color used on hover.
export const SOCIALS = [
  { testId: "footer-social-email", label: "Email", href: "mailto:mail@ryanmcolon.com", isMail: true, Icon: Mail, brand: "#5EEAD4" },
  { testId: "footer-social-github", label: "GitHub", href: "https://github.com/rmcunbound", Icon: Github, brand: "#F5F5F5" },
  { testId: "footer-social-linkedin", label: "LinkedIn", href: "https://linkedin.com/in/ryanmcolon", Icon: Linkedin, brand: "#0A66C2" },
  { testId: "footer-social-x", label: "X (Twitter)", href: "https://x.com/livelifeunbound", Icon: Twitter, brand: "#FFFFFF" },
  { testId: "footer-social-facebook", label: "Facebook", href: "https://facebook.com/ryanc6425", Icon: Facebook, brand: "#1877F2" },
  { testId: "footer-social-instagram", label: "Instagram", href: "https://instagram.com/rmc.influencer", Icon: Instagram, brand: "#E4405F" },
  { testId: "footer-social-youtube", label: "YouTube", href: "https://youtube.com/@rmcunbound", Icon: Youtube, brand: "#FF0000" },
  { testId: "footer-social-tiktok", label: "TikTok", href: "https://tiktok.com/@ryanmcolon", Icon: SiTiktok, brand: "#FF0050" },
  { testId: "footer-social-pinterest", label: "Pinterest", href: "https://pinterest.com/rmcunbound", Icon: SiPinterest, brand: "#E60023" },
  { testId: "footer-social-reddit", label: "Reddit", href: "https://reddit.com/u/rmcunbound", Icon: SiReddit, brand: "#FF4500" },
  { testId: "footer-social-vimeo", label: "Vimeo", href: "https://vimeo.com/ryanmcolon", Icon: SiVimeo, brand: "#1AB7EA" },
  { testId: "footer-social-snapchat", label: "Snapchat", href: "https://snapchat.com/add/ryanc6425", Icon: SiSnapchat, brand: "#FFFC00" }
];

export const skills = [
  { name: "Online Advertising", level: 96, color: "--sky-blue", icon: "⚡" },
  { name: "Marketing Automation", level: 92, color: "--mint-green", icon: "🔋" },
  { name: "Lead Generation", level: 89, color: "--coin-gold", icon: "✨" },
  { name: "Affiliate Marketing", level: 93, color: "--heart-red", icon: "💪" },
  { name: "Content Creation", level: 87, color: "--primary", icon: "🎨" }
];

export const projects = [
  {
    id: 1,
    title: "RMC Unbound Store",
    description: "Four specialized shopping destinations under one roof for enhanced lifestyle",
    tags: ["E-Commerce", "Lifestyle", "Multi-Store"],
    coins: 25,
    details: "RMC Unbound Store brings together four specialized shopping destinations designed to enhance every aspect of your lifestyle. Our goal is to help you live smarter and better, with curated collections across Display, Smart Home, Wellness, and Pets categories.",
    link: "https://rmcunbound.store",
    subStores: [
      { name: "RMC Display", url: "https://display.rmcunbound.store", description: "Cutting-edge displays and tech accessories" },
      { name: "RMC Smart Home", url: "https://smarthome.rmcunbound.store", description: "Smart living solutions and home automation" },
      { name: "RMC Wellness", url: "https://wellness.rmcunbound.store", description: "Health, fitness, and self-care essentials" },
      { name: "RMC Pets", url: "https://pets.rmcunbound.store", description: "Quality products for your furry companions" }
    ]
  }
];
